import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import {
    AppBar,
    Autocomplete,
    Box,
    Button,
    ButtonGroup,
    Checkbox,
    Dialog,
    FormControlLabel,
    Grid,
    IconButton,
    MenuItem,
    Modal,
    Slide,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Toolbar,
    Typography,
} from '@mui/material';
import { Radio, Select } from 'antd';
import { useSnackbar } from 'notistack';
import React, { memo, useContext, useEffect, useState } from 'react';
import InputField from '../../../../reusable-component/InputField';
import LoadingIcon from '../../../../reusable-component/LoadingIcon';

import {
    fetchSnowflakeColumns,
    fetchSnowFlakeDatabase,
    fetchSnowFlakeSchema,
    fetchSnowflakeTables,
} from "../../../../api's/SnowflakeApi";
import { AuthContext } from '../../../../context/AuthProvider';
import { WorkflowContext } from '../../../../contexts/WorkflowProvider';
import { MAIN } from '../../../../utils/commonConstants';

const { Option } = Select;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const INITIALSTATE = {
  path: '',
  format: 'snowflake_read',
  action: '',
  persist: false,
  alias: '',
  persist_type: '',
  database: '',
  delimiter: ',',
  tablename: '',
  ignoreblanklines: false,
  skipheaders: false,
  columnshift: false,
  junkrecords: false,
  linebreak: false,
  distinct_rows: false,
  clientId: '',
  clientName: '',
  batchName: '',
  tableNameRead: '',
  trackingId: '',
  innerPath: '',
  file: '',
  dataTypeRead: 'source',
  pagination: false,
  lowerBound: '',
  upperBound: '',
  CDC: false,
  partitionColumn: '',
  numPartitions: '',
  sample_view: true,
  priority: '',
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: '#fff',
  border: '1px solid #000',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
};

const NodeModalReadSnowflake = ({ open, handleClose, nodeId, nodeName, nodes, edges, changeNodeName, setNodes }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { userId } = useContext(AuthContext);
  const { workflow } = useContext(WorkflowContext);
  const [formField, setFormField] = useState(INITIALSTATE);
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [DataType, setDataType] = useState('Source');
  const [isDataLoad, setisDataLoad] = useState(false);
  const [addColumn, setAddColumn] = useState('');
  const [tempHeader, setTempHeader] = useState([]);
  const [defaultValue, setDefaultValue] = useState('');
  const [attributeType, setAttributeType] = useState('static');

  const [SnowflakeDatabase, setSnowflakeDatabase] = useState([]);
  const [SnowflakeSchema, setSnowflakeSchema] = useState([]);
  const [SnowflakeTables, setSnowflakeTables] = useState([]);

  const [AllClient, setAllClient] = useState([]);
  const [AllBatch, setAllBatch] = useState([]);
  const [AllTable, setAllTable] = useState([]);
  const [AllTracking, setAllTracking] = useState([]);
  const [AllFiles, setAllFiles] = useState([]);

  const [OracleDatabases, setOracleDatabases] = useState([]);
  const [OracleTables, setOracleTables] = useState([]);
  const plainOptions = [
    {
      label: 'Source Data',
      value: 'Source',
    },
    {
      label: 'Refernced Data',
      value: 'Refernce',
    },
  ];

  const attributeOptions = [
    {
      label: 'Static',
      value: 'static',
    },
    {
      label: 'Function',
      value: 'function',
    },
  ];

  const [addColumnModalOpen, setAddColumnModalOpen] = useState(false);
  const handleAddColumnModalOpen = () => setAddColumnModalOpen(true);
  const handleAddColumnModalClose = () => setAddColumnModalOpen(false);

  const checklabel = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const handleHeaderChange = (obj) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === obj.header;
    });

    if (selectedIndex === -1 && obj.checked) {
      setHeaderName([...headerName, obj]);

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              header: obj.header,
              alias: obj.alias,
              checked: true,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && obj.checked) {
      setHeaderName((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && !obj.checked) {
      setHeaderName((current) =>
        current.filter((object) => {
          return object.header !== obj.header;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: false,
              alias: '',
              cast_datatype: 'string',
              attribute_type: 'static',
              default_value: '',
            };
          }

          return object;
        })
      );
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = fetchedHeader.map((n) => {
        const all = {
          header: n.header,
          alias: n.alias,
          checked: true,
          cast_datatype: 'string',
          attribute_type: 'static',
          default_value: '',
        };
        return all;
      });
      setHeaderName(newSelecteds);
      return;
    }
    setHeaderName([]);
  };

  const isSelected = (name) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === name;
    });

    return selectedIndex !== -1;
  };

  const handleAddColumn = () => {
    setFetchedHeader([
      ...fetchedHeader,
      {
        header: addColumn,
        alias: '',
        checked: false,
        cast_datatype: 'string',
        default_value: defaultValue,
        attribute_type: attributeType,
      },
    ]);
    handleAddColumnModalClose();
  };

  const store = JSON.parse(sessionStorage.getItem('allNodes'));

  const getLocalData = () => {
    if (store) {
      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setisDataLoad(true);
          setHeaderName(node.headerName);
          setTempHeader(node.headerName);
          setFetchedHeader(node.fetchedHeader);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    getLocalData();
  }, [nodeId]);

  const sendFormData = {
    nodeId,
    nodeName,
    formField,
    disabled: false,
    step_name: nodeName,
  };

  let name, value;
  const handleInputChange = (e) => {
    name = e.target.name;
    if (
      name === 'ignoreblanklines' ||
      name === 'linebreak' ||
      name === 'skipheaders' ||
      name === 'columnshift' ||
      name === 'junkrecords' ||
      name === 'pagination'
    ) {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }

    setFormField({
      ...formField,
      [name]: value,
    });
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
    setHeaderName([]);
    setFetchedHeader([]);
    setTempHeader([]);
  };

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    const regex = /^s3:\/\//i;

    if (formField.path !== '' && DataType === 'refernce') {
      if (!regex.test(formField.path)) {
        enqueueSnackbar('S3 path is invalid!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
        return;
      }
    }

    const newHeaderName = [];

    headerName.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        // y_axis = `${parseInt(el.position.y, 10)}`;
        el.data.label = formField.alias;
      }
    });

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField,
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      fetchedHeader,
      // flowbuilderRowLevelOperation
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });

    // setTempHeader(headerName);

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };

  useEffect(() => {
    if (isDataLoad) {
      // getClient();
    }
  }, [isDataLoad]);

  const getSnowFlakeDatabase = async () => {
    try {
      const response = await fetchSnowFlakeDatabase();
      if (response.status === 200) {
        const db = [];
        response.data.forEach((el) => {
          db.push(el.name);
        });
        setSnowflakeDatabase(db);
      }
    } catch (error) {
      enqueueSnackbar('Databases not found!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  const getSnowFlakeSchema = async (database) => {
    try {
      const response = await fetchSnowFlakeSchema(database);
      if (response.status === 200) {
        const schema = [];
        response.data.forEach((el) => {
          schema.push(el.name);
        });
        setSnowflakeSchema(schema);
      }
    } catch (error) {
      enqueueSnackbar('Tables not found!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  const getSnowflakeTables = async (dbname, schema) => {
    try {
      const response = await fetchSnowflakeTables(dbname, schema);
      if (response.status === 200) {
        const tables = [];
        response.data.forEach((el) => {
          tables.push(el.name);
        });
        setSnowflakeTables(tables);
      }
    } catch (error) {
      enqueueSnackbar('Tables not found!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  const getSnowflakeTableColumns = async () => {
    const response = await fetchSnowflakeColumns(formField.database, formField.schema, formField.tablename);
    if (response.status === 200) {
      const cols = [];
      response.data.forEach((ele) => {
        cols.push({
          header: ele,
          alias: '',
          checked: true,
          cast_datatype: 'string',
          attribute_type: 'static',
          default_value: '',
        });
      });
      console.log(cols);
      setFetchedHeader(cols);
    }
  };
  const snowflakeDataApi = async () => {
    if (formField.alias) {
      console.log('');
    } else if (formField.format === 'snowflake_read' && formField.database && formField.schema && formField.tablename) {
      await getSnowflakeTableColumns();
    } else if (formField.format === 'snowflake_read' && formField.database && formField.schema) {
      await getSnowflakeTables(formField.database, formField.schema);
    } else if (formField.format === 'snowflake_read' && formField.database) {
      await getSnowFlakeSchema(formField.database);
    } else if (formField.format === 'snowflake_read') {
      await getSnowFlakeDatabase();
    }
  };

  useEffect(() => {
    if (formField.format === 'snowflake_read' && formField.database) {
      getSnowFlakeSchema(formField.database);
    }
  }, [formField.database]);

  useEffect(() => {
    if (formField.format === 'snowflake_read' && formField.schema) {
      getSnowflakeTables(formField.database, formField.schema);
    }
  }, [formField.schema]);

  useEffect(() => {
    if (formField.format === 'snowflake_read' && formField.tablename) {
      getSnowflakeTableColumns();
    }
  }, [formField.tablename]);

  useEffect(() => {
    snowflakeDataApi();
  }, [formField]);

  const handleChecked = (event) => {
    setFormField({ ...formField, sample_view: event.target.checked });
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        // onClose={handleClose}
        TransitionComponent={Transition}
        style={{ width: '70%', marginLeft: '30%' }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar color="inherit" sx={{ position: 'relative' }}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                {nodeName}
              </Typography>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button size="small" variant="outlined" className="outlined-button-color" onClick={handleEdit}>
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>
          <div style={{ margin: '20px' }}>
            <input type="hidden" value={nodeId} />

            <Box
              component="form"
              sx={{
                '& > :not(style)': { m: 2, width: '32ch' },
              }}
              noValidate
              autoComplete="off"
            >
              <InputField
                name="alias"
                label="Alias"
                value={formField.alias}
                onChange={handleInputChange}
                size="small"
                disabled={disableForm}
                required
              />
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={formField.sample_view}
                    onChange={handleChecked}
                    disabled={disableForm}
                  />
                }
                label="Sample View"
              />
            </Box>
            <Box
              component="form"
              sx={{
                '& > :not(style)': { m: 2, width: '32ch' },
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                id="outlined-basic"
                // select
                label="Format"
                variant="outlined"
                value="snowflake_read"
                onChange={handleInputChange}
                name="format"
                sx={{ mt: 2 }}
                size="small"
                disabled
                required
                InputProps={{
                  style: {
                    fontFamily: "'EB Garamond', serif ",
                    fontWeight: 600,
                  },
                }}
                InputLabelProps={{ style: { fontFamily: "'EB Garamond', serif " } }}
              />
              {workflow.process_type === MAIN.xperience360 && (
                <InputField
                  name="priority"
                  label="Priority"
                  value={formField.priority}
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                  required
                />
              )}

              {formField.format === 'snowflake_read' && (
                <>
                  <Grid item xs={4}>
                    {formField.format && (
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        name="database"
                        value={formField.database}
                        disabled={disableForm}
                        onChange={(event, newValue) => {
                          setFormField({
                            ...formField,
                            database: newValue,
                          });
                        }}
                        options={SnowflakeDatabase}
                        style={{ width: '100%', marginTop: '15px' }}
                        size="small"
                        renderInput={(params) => <TextField {...params} label="Databases" />}
                      />
                    )}
                  </Grid>
                  <Grid item xs={4}>
                    {formField.database && (
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        name="schema"
                        value={formField.schema}
                        disabled={disableForm}
                        onChange={(event, newValue) => {
                          setFormField({
                            ...formField,
                            schema: newValue,
                          });
                        }}
                        options={SnowflakeSchema}
                        style={{ width: '100%', marginTop: '15px' }}
                        size="small"
                        renderInput={(params) => <TextField {...params} label="Schemas" />}
                      />
                    )}
                  </Grid>

                  <Grid item xs={4}>
                    {formField.schema && (
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        name="tablename"
                        value={formField.tablename}
                        disabled={disableForm}
                        onChange={(event, newValue) => {
                          setFormField({
                            ...formField,
                            tablename: newValue,
                          });
                        }}
                        options={SnowflakeTables}
                        style={{ width: '100%', marginTop: '15px' }}
                        size="small"
                        renderInput={(params) => <TextField {...params} label="Tables" />}
                      />
                    )}
                  </Grid>
                </>
              )}
            </Box>

            {loadingBtn && (
              <Box>
                <LoadingIcon />
              </Box>
            )}

            {!loadingBtn && fetchedHeader.length > 0 && (
              <TableContainer sx={{ maxHeight: 300 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Checkbox
                          color="primary"
                          checked={fetchedHeader.length === headerName.length}
                          onChange={handleSelectAllClick}
                        />
                        Select Columns
                      </TableCell>
                      <TableCell>Columns</TableCell>
                      <TableCell>Datatype</TableCell>
                      <TableCell>Alias</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fetchedHeader.map((row, i) => {
                      const isItemSelected = isSelected(row.header);
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={i}
                          selected={isItemSelected}
                        >
                          <TableCell>
                            <Checkbox
                              checked={isItemSelected}
                              disabled={disableForm}
                              onChange={(event) =>
                                handleHeaderChange({
                                  header: row.header,
                                  alias: '',
                                  checked: event.target.checked,
                                  cast_datatype: row.cast_datatype ? row.cast_datatype : 'string',
                                  attribute_type: row.attribute_type,
                                  default_value: row.default_value,
                                })
                              }
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </TableCell>
                          <TableCell>{row.header}</TableCell>
                          <TableCell>
                            <TextField
                              id="standard-select-currency"
                              select
                              label="Cast Datatype"
                              name="cast_datatype"
                              disabled={disableForm}
                              value={row.cast_datatype ? row.cast_datatype : 'string'}
                              onChange={(event) =>
                                handleHeaderChange({
                                  header: row.header,
                                  alias: row.alias,
                                  checked: true,
                                  cast_datatype: event.target.value,
                                  attribute_type: row.attribute_type,
                                  default_value: row.default_value,
                                })
                              }
                              style={{ width: '100%' }}
                              size="small"
                            >
                              <MenuItem value="int">Integer</MenuItem>
                              <MenuItem value="string">String</MenuItem>
                              <MenuItem value="float">Float</MenuItem>
                              <MenuItem value="timestamp">Timestamp</MenuItem>
                            </TextField>
                          </TableCell>

                          <TableCell>
                            <TextField
                              name="alias"
                              label="Alias"
                              value={row.alias}
                              disabled={disableForm}
                              onChange={(e) =>
                                handleHeaderChange({
                                  header: row.header,
                                  alias: e.target.value,
                                  checked: true,
                                  cast_datatype: row.cast_datatype ? row.cast_datatype : 'string',
                                  attribute_type: row.attribute_type,
                                  default_value: row.default_value,
                                })
                              }
                              size="small"
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <Box
              component="form"
              sx={{
                '& > :not(style)': { m: 2, width: '32ch' },
              }}
              noValidate
              autoComplete="off"
            >
              <Button
                disabled={disableForm}
                variant="contained"
                endIcon={<AddIcon />}
                onClick={handleAddColumnModalOpen}
              >
                Add Column
              </Button>
              <TextField
                id="outlined-basic"
                select
                label="Persist"
                variant="outlined"
                value={formField.persist}
                name="persist"
                onChange={handleInputChange}
                sx={{ mt: 2 }}
                size="small"
                disabled={disableForm}
                required
                InputProps={{
                  style: {
                    fontFamily: "'EB Garamond', serif ",
                    fontWeight: 600,
                  },
                }}
                InputLabelProps={{ style: { fontFamily: "'EB Garamond', serif " } }}
              >
                <MenuItem value>true</MenuItem>
                <MenuItem value={false}>false</MenuItem>
              </TextField>

              {formField.persist === true && (
                <TextField
                  id="outlined-basic"
                  select
                  label="Persist Type"
                  variant="outlined"
                  value={formField.persist_type}
                  name="persist_type"
                  onChange={handleInputChange}
                  sx={{ mt: 2 }}
                  size="small"
                  disabled={disableForm}
                  required
                >
                  <MenuItem value="DISK_ONLY">DISK_ONLY</MenuItem>
                  <MenuItem value="DISK_ONLY_2">DISK_ONLY_2</MenuItem>
                  <MenuItem value="MEMORY_ONLY">MEMORY_ONLY</MenuItem>
                  <MenuItem value="MEMORY_ONLY_2">MEMORY_ONLY_2</MenuItem>
                  <MenuItem value="MEMORY_AND_DISK">MEMORY_AND_DISK</MenuItem>
                  <MenuItem value="MEMORY_AND_DISK_2">MEMORY_AND_DISK_2</MenuItem>
                </TextField>
              )}
            </Box>
            <Grid container spacing={2} sx={{ mx: 1 }}>
              <Grid item xs={4}>
                <InputField
                  name="action"
                  label="Action"
                  value={formField.action}
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  id="outlined-select-currency"
                  select
                  label="Distinct Rows"
                  size="small"
                  value={formField.distinct_rows}
                  onChange={(event) => {
                    setFormField({
                      ...formField,
                      distinct_rows: event.target.value,
                    });
                  }}
                  disabled={disableForm}
                  style={{ width: '100%', marginTop: '15px' }}
                >
                  <MenuItem value="true">true</MenuItem>
                  <MenuItem value="false">false</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </div>
          <Modal
            open={addColumnModalOpen}
            onClose={handleAddColumnModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Radio.Group
                options={attributeOptions}
                size="large"
                name="DataTypeRadio"
                onChange={(e) => setAttributeType(e.target.value)}
                value={attributeType}
                disabled={disableForm}
              />
              <InputField
                name="header"
                label="Attribute"
                onChange={(e) => setAddColumn(e.target.value)}
                size="small"
                required
              />
              <InputField
                name="default_value"
                label="Default Value"
                onChange={(e) => setDefaultValue(e.target.value)}
                size="small"
                required
              />

              <Button
                variant="contained"
                sx={{ mt: 2, ml: 2 }}
                color="secondary"
                type="submit"
                className="button-color"
                onClick={handleAddColumn}
              >
                Add
              </Button>
            </Box>
          </Modal>
        </form>
      </Dialog>
    </div>
  );
};

export default memo(NodeModalReadSnowflake);
